import { IFinanceTableScrollPosition } from "./financeCommonTypes";

export const getScrollPositionPercent = (data: number | Partial<IFinanceTableScrollPosition>) => {
  if (typeof data === "number") return data;
  if (!data) return 0;
  return ((data.scrollPosition ?? 0) / (data.containerWidth ?? 0)) * 100;
};
